/**
 * Medallia parameters
 */
export const MEDALLIA_SURVEY_ENVIRONMENT_PARAMETER_NAME = "environment";
export const MEDALLIA_CONTACT_FORM_DISPLAY_SURVEY_PARAMETER_NAME = "displayContactFormSurvey";
export const MEDALLIA_ADD_LOCATION_DISPLAY_SURVEY_PARAMETER_NAME = "displayAddLocationSurvey";
export const MEDALLIA_DASHBOARD_DISPLAY_SURVEY_PARAMETER_NAME = "displayDashboardSurvey";

/**
 * Forms IDs
 */
export const ALWAYS_ON_FEEDBACK_FORM_ID = 32370;

/**
 * Configs
 */
export const SURVEY_DELAY = 3000; // Milliseconds
export const TIME_ON_PAGE_SURVEY_TRIGGER = 60000 - SURVEY_DELAY; // Milliseconds
